import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopUpMessageComponent } from '../pop-up-message/pop-up-message.component';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-pop-up-denied-request',
  templateUrl: './pop-up-denied-request.component.html',
  styleUrls: ['./pop-up-denied-request.component.css']
})
export class PopUpDeniedRequestComponent {

  selectedDocuments = new FormControl({ value: '', disabled: false });
  comment = '';
  showSendButton = false;
  requestType: string = '';
  requestId: string = '';

  riparianParkingDocumentsList: string[] = [
    'Buletin expirat',
    'Buletin cu altă adresă și lipsă flotant',
    'Flotant expirat',
    'Talon expirat',
    'Document(e) ilizibile'
  ];

  homeParkingDocumentsList: string[] = [
    'ITP expirat',
    'Asigurare obligatorie expirată',
    'Buletin expirat',
    'Buletin cu altă adresă și lipsă flotant',
    'Flotant expirat',
    'Lipsă contract de comodat',
    'Lipsă adeverință de la firmă',
    'Mașina nu este înmatriculată pe Bihor',
    'Document(e) ilizibile',
    'Adresa din buletin pe Oradea cu mașina înmatriculată pe alt județ'
  ];

  constructor(
    private apiService: ApiService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<PopUpDeniedRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { requestType: string, requestId: string }
  ) {
    this.requestType = data.requestType;
    this.requestId = data.requestId;
  }

  openDialog(requestId: string): void {
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '400px',
      data: { comment: this.comment, requestId: requestId }
    });

    dialogRef.afterClosed().subscribe((status: string) => {
      if (status === 'rejected') {
        this.dialogRef.close(status);
      }
    });
  }

  sendOption(): void {
    const option = this.selectedDocuments.value;
    const status = 'rejected';
    let rejectionReason = '';

    if (this.requestType === 'riparian') {
      rejectionReason = this.riparianParkingDocumentsList.find(reason => reason === option) || '';
    } else if (this.requestType === 'home') {
      rejectionReason = this.homeParkingDocumentsList.find(reason => reason === option) || '';
    }

    this.selectedDocuments.disable();
    this.apiService.putSubscriptionRequestById(this.requestId, status, rejectionReason).subscribe(
      () => {
        this.dialogRef.close(status);
      },
      (error) => {
        console.error('Error denying request:', error);
      }
    );
  }


}
